<template>
  <div align="Left">
    <md-card id="organizations" align="Left" style="margin-top: 4rem;"">
      <md-card-header class=" md-card-header-icon md-card-header-green">
      <div class="card-icon">
        <i class="material-icons">business</i>
      </div>
      <h4 class="title">Clients List</h4>

      <div class="md-layout md-gutter md-layout-item md-size-100 md-alignment-center-right"
        style="padding: 0 0.3rem 0 0; justify-content: space-between">
        <div class="md-layout md-gutter md-layout-item"
          style="display: flex; align-items: center; justify-content: left; padding: 0">
          <md-field class="md-sm" style="width: 200px">
            <label>Search</label>
            <md-input v-model="searchQuery" />
          </md-field>
        </div>
        <div>
          <md-button class="md-icon-button md-primary" @click="createOrg">
            <md-icon>add</md-icon>
            <md-tooltip md-direction="bottom">Add new client</md-tooltip>
          </md-button>
          <md-button class="md-icon-button" @click="handleRefresh">
            <md-icon>refresh</md-icon>
            <md-tooltip md-direction="bottom">Refresh list</md-tooltip>
          </md-button>
        </div>
      </div>

      <!-- <hr v-if="!isLoading" /> -->
      </md-card-header>

      <md-card-content style="padding-top: 0px" v-if="!isLoading">
        <md-table :value="tableData" class="table-shopping table-striped table-hover"
          @click.native="labelSort($event, false)" style="margin-bottom: 1rem">
          <md-table-row>
            <md-table-empty-state :md-description="`No clients found for this time frame or search criteria`"
              md-label="No clients found" />
          </md-table-row>
          <md-table-row slot="md-table-row" slot-scope="{ item }">
            <md-table-cell />
            <md-table-cell md-label="Code">{{ item.orgCode || '-' }}</md-table-cell>
            <md-table-cell md-label="Client Name">{{ item.name || '-' }}</md-table-cell>
            <md-table-cell md-label="Contact Name">{{ item.contactName || '-' }}</md-table-cell>
            <md-table-cell md-label="Business Name">{{ item.businessName || '-' }}</md-table-cell>
            <md-table-cell md-label="Business Type">{{ businessTypes.length ? businessTypesObject[item.businessType] ||
              '-' : '' }}</md-table-cell>
            <md-table-cell md-label="Domain">{{ item.domain || '-' }}</md-table-cell>
            <md-table-cell>
              <div style="display: flex;justify-content: end;">
                <md-button class="md-icon-button"
                  style="width: 36px; height:27px;display: flex;align-items: center;justify-content: center;"
                  @click.stop="handleEdit(item)">
                  <md-icon>edit</md-icon>
                  <md-tooltip md-direction="bottom">Edit client</md-tooltip>
                </md-button>
                <md-button class="md-icon-button md-danger"
                  style="width: 36px; height:27px;display: flex;align-items: center;justify-content: center;margin-left: 0.5rem;"
                  @click.stop="handleRemove(item)">
                  <md-icon>delete</md-icon>
                  <md-tooltip md-direction="bottom">Remove client</md-tooltip>
                </md-button>
              </div>
            </md-table-cell>
            <md-table-cell />
          </md-table-row>
        </md-table>

        <!-- <hr /> -->
        <div style="display: flex; align-items: center">
          <!-- <div class="pagination-container" style="flex: 1; justify-content: start; height: 50%">
            <a :disabled="offset === 0" class="page-link" style="color: #999" aria-label="Previous" @click="prevPage">
              <i class="fas fa-angle-double-left" />
            </a>
            <span
              class="page-link"
              style="background-color: #4caf50; color: white; padding: 5px 10px; border-radius: 16px"
              >{{ currentPage }}</span
            >
            <a class="page-link" aria-label="Next" style="color: #999" @click="nextPage">
              <i class="fas fa-angle-double-right" />
            </a>
          </div> -->
          <div class="table table-stats" style="display: flex; justify-content: center; align-items: start; flex: 2">
            <div class="text-right">
              <p class="card-category">
                Showing from
                <b><u>{{ startOrganization }}</u></b>
                to
                <b><u>{{ endOrganization }}</u></b>. Total of
                <b><u>{{ totalOrganizations }}</u></b>
                clients.
              </p>
            </div>
          </div>
          <!-- <md-field style="flex: 1; margin-top: 1.5rem">
            <label for="pages">Per page</label>
            <md-select v-model="pagination.perPage" name="pages" @change="updateLimit">
              <md-option v-for="item in pagination.perPageOptions" :key="item" :value="item">
                {{ item }}
              </md-option>
            </md-select>
          </md-field> -->
        </div>
      </md-card-content>
    </md-card>

    <md-dialog :md-active.sync="showClientFormModal" v-if="!showLocationFormModal">
      <md-dialog-title style="background-color: rgb(11, 108, 141);color: #fff;margin-bottom: 0;padding: 1rem 24px;">
        {{ clientSelected ? 'Update Client' : 'Create Client' }}
      </md-dialog-title>
      <md-dialog-content style="margin-top: .5rem;padding: 0 24px;min-width: 350px;max-width: 550px;"
        id="client-info-dialog-content">
        <md-tabs id="client-tabs" :class="[{ 'md-transparent': true }, { 'client-tabs-creation': !clientSelected }]"
          md-alignment="fixed">
          <md-tab id="tab-client-info" md-label="Client Info">
            <div>
              <md-field :class="[
                { 'md-valid': !errors.has('clientName') && touched.clientName },
                { 'md-form-group': false },
                { 'md-error': errors.has('clientName') && touched.clientName }
              ]">
                <label>Client Name</label>
                <md-input v-validate="'required|max:45'" type="text" name="clientName" data-vv-name="clientName"
                  v-model="clientName"></md-input>
                <slide-y-down-transition>
                  <md-icon v-show="errors.has('clientName')" class="error">close</md-icon>
                </slide-y-down-transition>
                <slide-y-down-transition>
                  <md-icon v-show="!errors.has('clientName') && touched.clientName" class="success">done</md-icon>
                </slide-y-down-transition>
              </md-field>

              <md-field :class="[
                { 'md-valid': !errors.has('businessType') && touched.businessType },
                { 'md-form-group': false },
                { 'md-error': errors.has('businessType') && touched.businessType }
              ]">
                <label>Business Type</label>
                <md-select v-validate="'required'" name="businessType" data-vv-name="businessType"
                  v-model="businessType">
                  <md-option v-for="item in businessTypes" :key="item.LookupId" :value="item.LookupId" class="mselect">
                    {{ item.DisplayValue }}
                  </md-option>
                </md-select>
                <slide-y-down-transition>
                  <md-icon style="margin-right: 24px;background: white;" v-show="errors.has('businessType')"
                    class="error">close</md-icon>
                </slide-y-down-transition>
                <slide-y-down-transition>
                  <md-icon style="margin-right: 24px;background: white;"
                    v-show="!errors.has('businessType') && touched.businessType" class="success">done</md-icon>
                </slide-y-down-transition>
              </md-field>

              <md-field :class="[
                { 'md-valid': !errors.has('businessName') && touched.businessName },
                { 'md-form-group': false },
                { 'md-error': errors.has('businessName') && touched.businessName }
              ]">
                <label>Business Name</label>
                <md-input v-validate="'required|max:45'" type="text" name="businessName" data-vv-name="businessName"
                  v-model="businessName"></md-input>
                <slide-y-down-transition>
                  <md-icon v-show="errors.has('businessName')" class="error">close</md-icon>
                </slide-y-down-transition>
                <slide-y-down-transition>
                  <md-icon v-show="!errors.has('businessName') && touched.businessName" class="success">done</md-icon>
                </slide-y-down-transition>
              </md-field>

              <md-field :class="[
                { 'md-valid': !errors.has('domain') && touched.domain },
                { 'md-form-group': false },
                { 'md-error': errors.has('domain') && touched.domain }
              ]">
                <label>Domain</label>
                <md-input v-validate="'required|max:100'" type="text" name="domain" data-vv-name="domain"
                  v-model="domain"></md-input>
                <span :style="touched.domain ? 'margin-right: 24px;background: white;' : ''"
                  class="md-suffix">.globechek.com</span>
                <slide-y-down-transition>
                  <md-icon v-show="errors.has('domain')" class="error">close</md-icon>
                </slide-y-down-transition>
                <slide-y-down-transition>
                  <md-icon v-show="!errors.has('domain') && touched.domain" class="success">done</md-icon>
                </slide-y-down-transition>
              </md-field>

              <md-field :class="[
                { 'md-valid': !errors.has('contactName') && touched.contactName },
                { 'md-form-group': false },
                { 'md-error': errors.has('contactName') && touched.contactName }
              ]">
                <label>Contact Name</label>
                <md-input v-validate="'max:100'" type="text" name="contactName" data-vv-name="contactName"
                  v-model="contactName"></md-input>
                <slide-y-down-transition>
                  <md-icon v-show="errors.has('contactName')" class="error">close</md-icon>
                </slide-y-down-transition>
                <slide-y-down-transition>
                  <md-icon v-show="!errors.has('contactName') && touched.contactName" class="success">done</md-icon>
                </slide-y-down-transition>
              </md-field>

              <md-field :class="[
                { 'md-valid': !errors.has('contactEmail') && touched.contactEmail },
                { 'md-form-group': false },
                { 'md-error': errors.has('contactEmail') && touched.contactEmail }
              ]">
                <label>Contact Email</label>
                <md-input v-validate="'max:100|email'" type="text" name="contactEmail" data-vv-name="contactEmail"
                  v-model="contactEmail"></md-input>
                <slide-y-down-transition>
                  <md-icon v-show="errors.has('contactEmail')" class="error">close</md-icon>
                </slide-y-down-transition>
                <slide-y-down-transition>
                  <md-icon v-show="!errors.has('contactEmail') && touched.contactEmail" class="success">done</md-icon>
                </slide-y-down-transition>
              </md-field>

              <md-field :class="[
                { 'md-valid': !errors.has('contactPhone') && touched.contactPhone },
                { 'md-form-group': false },
                { 'md-error': errors.has('contactPhone') && touched.contactPhone }
              ]">
                <label>Contact Phone</label>
                <md-input v-mask="'(999) 999-9999'" v-validate="'min:14'" type="text" name="contactPhone"
                  data-vv-name="contactPhone" v-model="contactPhone"></md-input>
                <slide-y-down-transition>
                  <md-icon v-show="errors.has('contactPhone')" class="error">close</md-icon>
                </slide-y-down-transition>
                <slide-y-down-transition>
                  <md-icon v-show="!errors.has('contactPhone') && touched.contactPhone" class="success">done</md-icon>
                </slide-y-down-transition>
              </md-field>

              <md-field>
                <label style="margin: -10px 0 0 45px;">Clearing House Integration</label>
                <md-switch style="margin-top: 0;" v-model="enableClearingHouseIntegration"></md-switch>
              </md-field>
            </div>

            <div
              v-if="touched.contactPhone && enableClearingHouseIntegration && locationsData.find(i => !i.ensoraPayerId || !i.ein || !i.npi || !i.vendorSiteId)"
              style="color: red;font-size: 12px;">
              All your locations should have Payer, EIN, NPI and Vendor Site ID filled
            </div>

          </md-tab>
          <md-tab id="tab-pages" md-label="Locations">
            <h4 style="display: flex;align-items: center;justify-content: space-between;">
              <span>
                Locations
              </span>
              <md-button style="height: 32px;" class="md-icon-button md-primary" @click="createLocation">
                <md-icon>add</md-icon>
                <md-tooltip md-direction="bottom">Add new location</md-tooltip>
              </md-button>
            </h4>

            <md-table :value="locationsData" class="table-shopping table-striped table-hover"
              style="margin-bottom: 1rem">
              <md-table-row>
                <md-table-empty-state :md-description="`No locations found for this client`"
                  md-label="No locations found" />
              </md-table-row>
              <md-table-row slot="md-table-row" slot-scope="{ item }">
                <md-table-cell />
                <md-table-cell md-label="Location Name">{{ item.locationName || '-' }}</md-table-cell>
                <md-table-cell md-label="Device">{{ devices.length ? devicesObject[item.deviceId] || '-' : ''
                }}</md-table-cell>
                <md-table-cell md-label="Device Status">{{ item.deviceStatus ? deviceStatusObject[item.deviceStatus] ||
                  '-' : '' }}</md-table-cell>
                <md-table-cell>
                  <div style="display: flex;justify-content: end;">
                    <md-button class="md-icon-button"
                      style="width: 36px; height:27px;display: flex;align-items: center;justify-content: center;"
                      @click.stop="handleEditLocation(item)">
                      <md-icon>edit</md-icon>
                      <md-tooltip md-direction="bottom">Edit location</md-tooltip>
                    </md-button>
                    <md-button class="md-icon-button md-danger"
                      style="width: 36px; height:27px;display: flex;align-items: center;justify-content: center;margin-left: 0.5rem;"
                      @click.stop="handleRemoveLocation(item)">
                      <md-icon>delete</md-icon>
                      <md-tooltip md-direction="bottom">Remove location</md-tooltip>
                    </md-button>
                  </div>
                </md-table-cell>
                <md-table-cell />
              </md-table-row>
            </md-table>

            <div style="font-style: italic;margin-bottom: 1rem;font-size: 14px;">
              *Changes will be applied only after saving client information
            </div>

            <div
              v-if="touched.contactPhone && enableClearingHouseIntegration && locationsData.find(i => !i.ensoraPayerId || !i.ein || !i.npi || !i.vendorSiteId)"
              style="color: red;font-size: 12px;">
              All your locations should have Payer, EIN and NPI filled
            </div>

          </md-tab>
        </md-tabs>
      </md-dialog-content>

      <md-dialog-actions style="justify-content: center;margin-bottom: 1rem;padding: 0;">
        <md-button :disabled="isSaving"
          style="width: 100px;background-color: white !important;box-shadow: none;color: #000 !important;"
          @click="closeClientFormModal()">Cancel</md-button>
        <md-button class="md-primary" :disabled="isSaving" style="width: 100px;" @click="handleSaveClient()"><span
            :class="[{ 'saving': isSaving }]">{{ isSaving ? 'Saving...' : 'Save' }}</span></md-button>
      </md-dialog-actions>
    </md-dialog>

    <md-dialog :md-active.sync="showLocationFormModal">
      <md-dialog-title style="background-color: rgb(11, 108, 141);color: #fff;margin-bottom: 0;padding: 1rem 24px;">
        {{ locationSelected ? 'Update Location' : 'Create Location' }}
      </md-dialog-title>
      <md-dialog-content style="margin-top: .5rem;padding: 0 24px;">
        <div>
          <v-row>
            <v-col style="padding-bottom: 0;">
              <md-field :class="[
                { 'md-valid': !errors.has('locationName') && touched.locationName },
                { 'md-form-group': false },
                { 'md-error': errors.has('locationName') && touched.locationName }
              ]">
                <label>Location Name</label>
                <md-input v-validate="'required|max:45'" type="text" name="locationName" data-vv-name="locationName"
                  v-model="locationName"></md-input>
                <slide-y-down-transition>
                  <md-icon v-show="errors.has('locationName')" class="error">close</md-icon>
                </slide-y-down-transition>
                <slide-y-down-transition>
                  <md-icon v-show="!errors.has('locationName') && touched.locationName" class="success">done</md-icon>
                </slide-y-down-transition>
              </md-field>
            </v-col>
            <v-col style="padding-bottom: 0;">
              <md-field :class="[
                { 'md-valid': !errors.has('regionName') && touched.regionName },
                { 'md-form-group': false },
                { 'md-error': errors.has('regionName') && touched.regionName }
              ]">
                <label>Region Name</label>
                <md-select name="regionName" data-vv-name="regionName" v-model="regionName">
                  <md-option v-for="item in regions" :key="item.LookupId" :value="item.LookupId" class="mselect">
                    {{ item.DisplayValue }}
                  </md-option>
                </md-select>
                <slide-y-down-transition>
                  <md-icon style="margin-right: 24px;background: white;" v-show="errors.has('regionName')"
                    class="error">close</md-icon>
                </slide-y-down-transition>
                <slide-y-down-transition>
                  <md-icon style="margin-right: 24px;background: white;"
                    v-show="!errors.has('regionName') && touched.regionName" class="success">done</md-icon>
                </slide-y-down-transition>
              </md-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <md-field :class="[
                { 'md-valid': !errors.has('device') && touched.device },
                { 'md-form-group': false },
                { 'md-error': errors.has('device') && touched.device }
              ]">
                <label>Device</label>
                <md-select v-validate="'required'" name="device" data-vv-name="device" v-model="device">
                  <md-option v-for="item in devices" :key="item.id" :value="item.id" class="mselect">
                    {{ item.name }}
                  </md-option>
                </md-select>
                <slide-y-down-transition>
                  <md-icon style="margin-right: 24px;background: white;" v-show="errors.has('device')"
                    class="error">close</md-icon>
                </slide-y-down-transition>
                <slide-y-down-transition>
                  <md-icon style="margin-right: 24px;background: white;"
                    v-show="!errors.has('device') && touched.device" class="success">done</md-icon>
                </slide-y-down-transition>
              </md-field>
            </v-col>
            <v-col>
              <md-field :class="[
                { 'md-valid': !errors.has('deviceStatus') && touched.deviceStatus },
                { 'md-form-group': false },
                { 'md-error': errors.has('deviceStatus') && touched.deviceStatus }
              ]">
                <label>Device Status</label>
                <md-select name="deviceStatus" data-vv-name="deviceStatus" v-model="deviceStatus">
                  <md-option v-for="item in deviceStatusList" :key="item.LookupId" :value="item.LookupId"
                    class="mselect">
                    {{ item.DisplayValue }}
                  </md-option>
                </md-select>
                <slide-y-down-transition>
                  <md-icon style="margin-right: 24px;background: white;" v-show="errors.has('deviceStatus')"
                    class="error">close</md-icon>
                </slide-y-down-transition>
                <slide-y-down-transition>
                  <md-icon style="margin-right: 24px;background: white;"
                    v-show="!errors.has('deviceStatus') && touched.deviceStatus" class="success">done</md-icon>
                </slide-y-down-transition>
              </md-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col style="padding-bottom: 0;">
              <md-field :class="[
                { 'md-valid': !errors.has('deviceStartDate') && touched.deviceStartDate },
                { 'md-form-group': false },
                { 'md-error': errors.has('deviceStartDate') && touched.deviceStartDate },
                { 'md-has-value': true },
              ]">
                <label>Start Date</label>
                <md-input placeholder=" " type="date" name="deviceStartDate" data-vv-name="deviceStartDate"
                  v-model="deviceStartDate"></md-input>
                <slide-y-down-transition>
                  <md-icon style="margin-right: 24px;background: white;" v-show="errors.has('deviceStartDate')"
                    class="error">close</md-icon>
                </slide-y-down-transition>
                <slide-y-down-transition>
                  <md-icon style="margin-right: 24px;background: white;"
                    v-show="!errors.has('deviceStartDate') && touched.deviceStartDate" class="success">done</md-icon>
                </slide-y-down-transition>
              </md-field>
            </v-col>
            <v-col style="padding-bottom: 0;">
              <md-field :class="[
                { 'md-valid': !errors.has('deviceEndDate') && touched.deviceEndDate },
                { 'md-form-group': false },
                { 'md-error': errors.has('deviceEndDate') && touched.deviceEndDate },
                { 'md-has-value': true },
              ]">
                <label>End Date</label>
                <md-input placeholder=" " type="date" name="deviceEndDate" data-vv-name="deviceEndDate"
                  v-model="deviceEndDate"></md-input>
                <slide-y-down-transition>
                  <md-icon style="margin-right: 24px;background: white;" v-show="errors.has('deviceEndDate')"
                    class="error">close</md-icon>
                </slide-y-down-transition>
                <slide-y-down-transition>
                  <md-icon style="margin-right: 24px;background: white;"
                    v-show="!errors.has('deviceEndDate') && touched.deviceEndDate" class="success">done</md-icon>
                </slide-y-down-transition>
              </md-field>
            </v-col>
          </v-row>

          <md-field :class="[
            { 'md-valid': !errors.has('address') && touched.address },
            { 'md-form-group': false },
            { 'md-error': errors.has('address') && touched.address }
          ]">
            <label>Address</label>
            <md-input v-validate="'required|max:100'" type="text" name="address" data-vv-name="address"
              v-model="address"></md-input>
            <slide-y-down-transition>
              <md-icon v-show="errors.has('address')" class="error">close</md-icon>
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon v-show="!errors.has('address') && touched.address" class="success">done</md-icon>
            </slide-y-down-transition>
          </md-field>

          <v-row>
            <v-col style="padding-bottom: 0;">
              <md-field :class="[
                { 'md-valid': !errors.has('city') && touched.city },
                { 'md-form-group': false },
                { 'md-error': errors.has('city') && touched.city }
              ]">
                <label>City</label>
                <md-input v-validate="'required|max:100'" type="text" name="city" data-vv-name="city"
                  v-model="city"></md-input>
                <slide-y-down-transition>
                  <md-icon v-show="errors.has('city')" class="error">close</md-icon>
                </slide-y-down-transition>
                <slide-y-down-transition>
                  <md-icon v-show="!errors.has('city') && touched.city" class="success">done</md-icon>
                </slide-y-down-transition>
              </md-field>
            </v-col>
            <v-col style="padding-bottom: 0;">

              <md-field :class="[
                { 'md-valid': !errors.has('state') && touched.state },
                { 'md-form-group': false },
                { 'md-error': errors.has('state') && touched.state }
              ]">
                <label>State</label>
                <md-select v-validate="'required'" name="state" data-vv-name="state" v-model="state">
                  <md-option v-for="item in states" :key="item.LookupId" :value="item.LookupId" class="mselect">
                    {{ item.DisplayValue }}
                  </md-option>
                </md-select>
                <slide-y-down-transition>
                  <md-icon style="margin-right: 24px;background: white;" v-show="errors.has('state')"
                    class="error">close</md-icon>
                </slide-y-down-transition>
                <slide-y-down-transition>
                  <md-icon style="margin-right: 24px;background: white;" v-show="!errors.has('state') && touched.state"
                    class="success">done</md-icon>
                </slide-y-down-transition>
              </md-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col style="padding-bottom: 0;">
              <md-field :class="[
                { 'md-valid': !errors.has('country') && touched.country },
                { 'md-form-group': false },
                { 'md-error': errors.has('country') && touched.country }
              ]">
                <label>Country</label>
                <md-select v-validate="'required'" name="country" data-vv-name="country" v-model="country">
                  <md-option v-for="item in countries" :key="item.LookupId" :value="item.LookupId" class="mselect">
                    {{ item.DisplayValue }}
                  </md-option>
                </md-select>
                <slide-y-down-transition>
                  <md-icon style="margin-right: 24px;background: white;" v-show="errors.has('country')"
                    class="error">close</md-icon>
                </slide-y-down-transition>
                <slide-y-down-transition>
                  <md-icon style="margin-right: 24px;background: white;"
                    v-show="!errors.has('country') && touched.country" class="success">done</md-icon>
                </slide-y-down-transition>
              </md-field>
            </v-col>
            <v-col style="padding-bottom: 0;">
              <md-field :class="[
                { 'md-valid': !errors.has('zip') && touched.zip },
                { 'md-form-group': false },
                { 'md-error': errors.has('zip') && touched.zip }
              ]">
                <label>Zip</label>
                <md-input v-validate="'required|max:100'" type="text" name="zip" data-vv-name="zip"
                  v-model="zip"></md-input>
                <slide-y-down-transition>
                  <md-icon v-show="errors.has('zip')" class="error">close</md-icon>
                </slide-y-down-transition>
                <slide-y-down-transition>
                  <md-icon v-show="!errors.has('zip') && touched.zip" class="success">done</md-icon>
                </slide-y-down-transition>
              </md-field>
            </v-col>
          </v-row>

          <div style="margin-top: 1rem;" v-if="enableClearingHouseIntegration">
            <h6>Clearing House Integration</h6>

            <v-row>
              <v-col style="padding-bottom: 0;">
                <md-autocomplete :class="[
                  { 'md-valid': !errors.has('payer') && touched.payer },
                  { 'md-form-group': false },
                  { 'md-error': errors.has('payer') && touched.payer }
                ]" v-validate="'required'" name="payer" data-vv-name="payer" v-model="payer"
                  :md-options="filteredEnsoraPayers" @md-changed="filterEnsoraPayers" @md-opened="filterEnsoraPayers">
                  <label>Payer</label>
                  <template slot="md-autocomplete-item" slot-scope="{ item }">{{ item }}</template>
                </md-autocomplete>
              </v-col>
            </v-row>

            <v-row>
              <v-col style="padding-bottom: 0;">
                <md-field :class="[
                  { 'md-valid': !errors.has('ein') && touched.ein },
                  { 'md-form-group': false },
                  { 'md-error': errors.has('ein') && touched.ein }
                ]">
                  <label>EIN</label>
                  <md-input v-mask="'99-9999999'"
                    v-validate="{ required: true, min: 10, max: 10, regex: /^\d{2}\-?\d{7}$/ }" type="text" name="ein"
                    data-vv-name="ein" v-model="ein"></md-input>
                  <slide-y-down-transition>
                    <md-icon style="margin-right: 24px;background: white;" v-show="errors.has('ein')"
                      class="error">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon style="margin-right: 24px;background: white;" v-show="!errors.has('ein') && touched.ein"
                      class="success">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </v-col>
              <v-col style="padding-bottom: 0;">
                <md-field :class="[
                  { 'md-valid': !errors.has('npi') && touched.npi },
                  { 'md-form-group': false },
                  { 'md-error': errors.has('npi') && touched.npi }
                ]">
                  <label>NPI</label>
                  <md-input v-mask="'9999999999'" v-validate="{ required: true, min: 10, max: 10, regex: /^\d{10}$/ }"
                    type="text" name="npi" data-vv-name="npi" v-model="npi"></md-input>
                  <slide-y-down-transition>
                    <md-icon v-show="errors.has('npi')" class="error">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon v-show="!errors.has('npi') && touched.npi" class="success">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <md-field :class="[
                  { 'md-valid': !errors.has('vendorSiteId') && touched.vendorSiteId },
                  { 'md-form-group': false },
                  { 'md-error': errors.has('vendorSiteId') && touched.vendorSiteId }
                ]">
                  <label>Vendor Site ID</label>
                  <md-input v-validate="{ required: true }" type="text" name="ein" data-vv-name="vendorSiteId"
                    v-model="vendorSiteId"></md-input>
                  <slide-y-down-transition>
                    <md-icon style="margin-right: 24px;background: white;" v-show="errors.has('vendorSiteId')"
                      class="error">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon style="margin-right: 24px;background: white;"
                      v-show="!errors.has('vendorSiteId') && touched.vendorSiteId" class="success">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </v-col>
            </v-row>
          </div>
          <div style="font-style: italic;margin-bottom: 1rem;font-size: 14px;">
            *Changes will be applied only after saving client information
          </div>
        </div>
      </md-dialog-content>

      <md-dialog-actions style="justify-content: center;margin-bottom: 1rem;padding: 0;">
        <md-button :disabled="isSaving"
          style="width: 100px;background-color: white !important;box-shadow: none;color: #000 !important;"
          @click="closeLocationFormModal()">Cancel</md-button>
        <md-button class="md-primary" style="width: 100px;" @click="handleSaveLocation()">{{ locationSelected ? 'Update'
          : 'Create' }}</md-button>
      </md-dialog-actions>
    </md-dialog>

    <loader :is-visible="isLoading" />
  </div>
</template>

<script>
import Swal from "sweetalert2";
import { mapGetters, mapActions } from "vuex"
import loader from "@/components/GlobeChek/loader.vue"
import { SlideYDownTransition } from "vue2-transitions"

export default {
  components: {
    loader,
    SlideYDownTransition
  },
  data() {
    return {
      tableData: [],
      originalData: [],
      businessTypes: [],
      regions: [],
      countries: [],
      states: [],
      devices: [],
      deviceStatusList: [],
      regionsObject: {},
      devicesObject: {},
      businessTypesObject: {},
      deviceStatusObject: {},
      searchQuery: "",
      searchedData: [],
      isLoading: false,
      selectedOrg: null,
      offset: 0,
      limit: 100,
      totalOrganizations: 0,
      pagination: {
        perPage: 100,
        perPageOptions: [10, 20, 50, 100, 200]
      },
      // form attributes client
      clientName: '',
      businessType: '',
      businessName: '',
      domain: '',
      contactName: '',
      contactEmail: '',
      contactPhone: '',
      enableClearingHouseIntegration: false,
      locationsData: [],

      ensoraPayers: [],
      filteredEnsoraPayers: [],
      // form attributes location
      locationName: '',
      regionName: '',
      device: '',
      deviceStatus: '',
      deviceStartDate: '',
      deviceEndDate: '',
      address: '',
      city: '',
      state: '',
      country: '',
      zip: '',
      payer: null,
      ein: '',
      npi: '',
      vendorSiteId: null,
      touched: {
        // client
        clientName: false,
        businessType: false,
        businessName: false,
        domain: false,
        contactName: false,
        contactEmail: false,
        contactPhone: false,

        //location
        locationName: false,
        regionName: false,
        device: false,
        deviceStatus: false,
        deviceStartDate: false,
        deviceEndDate: false,
        address: false,
        city: false,
        state: false,
        country: false,
        zip: false,
        payer: false,
        ein: false,
        npi: false,
        vendorSiteId: false,
      },
      isSaving: false,
      clientSelected: null,
      locationSelected: null,
      showClientFormModal: false,
      showLocationFormModal: false,
    }
  },
  computed: {
    ...mapGetters(["organizationList", "listLookupsByMasterName"]),
    currentPage() {
      return Math.floor(this.offset / this.limit) + 1
    },
    hasMoreData() {
      return this.offset + this.limit < this.totalOrganizations
    },
    startOrganization() {
      return this.totalOrganizations === 0 ? 0 : this.offset + 1
    },
    endOrganization() {
      return Math.min(this.offset + this.limit, this.totalOrganizations)
    }
  },
  watch: {
    searchQuery(value) {
      if (value === "") this.tableData = this.originalData
      else {
        const searchedData = this.originalData.filter(i => {
          const searchText = ((i.businessName || '') + (i.contactEmail || '') + (i.contactName || '') + (i.contactPhone || '') + (i.domain || '') + (i.name || '') + (i.orgCode || '')).toLowerCase()
          return searchText.includes(value.toLowerCase());
        })
        this.tableData = searchedData
      }
      this.totalOrganizations = this.tableData.length
    }
  },
  mounted() {
    this.isLoading = true
    this.fetchOrgs()
    this.fetchLookups()
    this.fetchEnsoraPayers()
  },
  methods: {
    ...mapActions(["listOrganizations"]),
    filterEnsoraPayers() {
      if (this.payer && this.payer.length > 0) {
        const searchText = this.payer.toLowerCase();
        this.filteredEnsoraPayers = this.ensoraPayers.map(i => i.name).filter(i => i.toLowerCase().includes(searchText)).slice(0, 50);
      } else {
        this.filteredEnsoraPayers = this.ensoraPayers.map(i => i.name).slice(0, 50);
      }
    },
    closeClientFormModal() {
      this.clientSelected = null;
      this.showClientFormModal = false;
    },
    async handleSaveClient() {
      this.touched.clientName = true;
      this.touched.businessType = true;
      this.touched.businessName = true;
      this.touched.domain = true;
      this.touched.contactName = true;
      this.touched.contactEmail = true;
      this.touched.contactPhone = true;
      this.contactPhone = this.contactPhone.replace(/_/g, '');
      const valid = await this.$validator.validateAll();
      if (!valid) return;

      if (this.enableClearingHouseIntegration && this.locationsData.find(i => !i.ensoraPayerId || !i.ein || !i.npi || !i.vendorSiteId)) {
        const element = document.getElementById('client-info-dialog-content');
        element.scrollTo(10000, 10000)
        return
      }
      try {
        this.isSaving = true;
        let domain = this.domain
        if (domain.split('.').length <= 1) {
          domain = this.domain + '.globechek.com'
        }
        const body = {
          id: this.clientSelected ? this.clientSelected.id : null,
          clientName: this.clientName,
          businessType: this.businessType,
          businessName: this.businessName,
          domain: domain,
          contactName: this.contactName,
          contactEmail: this.contactEmail,
          contactPhone: this.contactPhone,
          locations: this.locationsData,
          createdBy: sessionStorage.getItem("userID"),
          updatedBy: sessionStorage.getItem("userID"),
          enableClearingHouseIntegration: this.enableClearingHouseIntegration
        }
        if (body.id) {
          const config = { headers: { "Content-Type": "application/json" } };
          await window.axios.patch(`${process.env.VUE_APP_URL}/organisations/${body.id}`, body, config).then(res => res.data);
        } else {
          const config = { headers: { "Content-Type": "application/json" } };
          await window.axios.post(`${process.env.VUE_APP_URL}/organisations`, body, config).then(res => res.data);
        }
        Swal.fire({
          title: "Success",
          text: `Organization ${this.clientName} was ${!body.id ? 'created' : 'updated'} successully`,
          type: "success",
          confirmButtonClass: "md-button md-success btn-fill",
          buttonsStyling: false
        }).then(result => {
          this.searchQuery = '';
          this.fetchOrgs();
          this.showClientFormModal = false;
        })
      } catch (e) {
        console.log(e);
      } finally {
        this.isSaving = false;
      }
    },
    async fetchLookups() {
      try {
        const config = { headers: { "Content-Type": "application/json" } };
        this.businessTypes = await window.axios.get(`${process.env.VUE_APP_URL}/lookup/lookupmaster/BusinessType`, config).then(res => res.data);
        for (const i of this.businessTypes) {
          this.businessTypesObject[i.LookupId] = i.DisplayValue
        }
        this.regions = await window.axios.get(`${process.env.VUE_APP_URL}/lookup/lookupmaster/Regions`, config).then(res => res.data);
        for (const i of this.regions) {
          this.regionsObject[i.LookupId] = i.DisplayValue
        }
        this.countries = await window.axios.get(`${process.env.VUE_APP_URL}/lookup/lookupmaster/CountryCodes`, config).then(res => res.data);
        this.states = await window.axios.get(`${process.env.VUE_APP_URL}/lookup/lookupmaster/States`, config).then(res => res.data);
        this.deviceStatusList = await window.axios.get(`${process.env.VUE_APP_URL}/lookup/lookupmaster/DeviceStatus`, config).then(res => res.data);
        for (const i of this.deviceStatusList) {
          this.deviceStatusObject[i.LookupId] = i.DisplayValue
        }
        this.devices = await window.axios.get(`${process.env.VUE_APP_URL}/globes`, config).then(res => res.data);
        for (const i of this.devices) {
          this.devicesObject[i.id] = i.name
        }
      } catch (error) {
        console.error("Error when getting business types:", error)
      }
    },
    async fetchEnsoraPayers() {
      try {
        const config = { headers: { "Content-Type": "application/json" } };
        this.ensoraPayers = await window.axios.get(`${process.env.VUE_APP_URL}/clearinghouse/ensora/payers`, config).then(res => res.data);
        this.filteredEnsoraPayers = this.ensoraPayers.map(i => i.name);
      } catch (error) {
        console.error("Error when getting ensora payers:", error)
      }
    },
    handleEdit(item) {
      this.clientSelected = item;
      this.touched.clientName = false;
      this.touched.businessType = false;
      this.touched.businessName = false;
      this.touched.domain = false;
      this.touched.contactName = false;
      this.touched.contactEmail = false;
      this.touched.contactPhone = false;
      this.clientName = item.name;
      this.businessType = item.businessType;
      this.businessName = item.businessName;
      this.domain = item.domain.replace('.globechek.com', '');
      this.contactName = item.contactName;
      this.contactEmail = item.contactEmail;
      this.contactPhone = item.contactPhone;
      this.locationsData = item.locations.map(i => {
        i.internalId = (Math.random() + 1).toString(36).substring(7);
        return i;
      }) || [];
      this.enableClearingHouseIntegration = item.enableClearingHouseIntegration;
      this.showClientFormModal = true;
    },
    async handleRemove(item) {
      const response = await Swal.fire({
        title: "Confirmation",
        text: "Do you want to delete the this Client?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!"
      })
      if (response.value) {
        try {
          this.isLoading = true;
          const url = `${process.env.VUE_APP_URL}/organisations/${item.id}`;
          await window.axios.delete(url).then(r => r.data);
          this.fetchOrgs();
          this.searchQuery = '';
          Swal.fire({
            title: "Deleted!",
            text: "Client has been deleted.",
            confirmButtonText: "OK"
          })
        } catch (error) {
          this.isLoading = false;
          Swal.fire({
            title: "Error!",
            text: "Error: " + error,
            confirmButtonText: "Try Again"
          })
        }
      }

    },
    async fetchOrgs() {
      this.isLoading = true
      try {
        const response = await this.listOrganizations()
        response.sort((a, b) => a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1)
        this.tableData = response
        this.originalData = response
        this.totalOrganizations = response.length
      } catch (error) {
        console.error(error)
      } finally {
        this.isLoading = false
      }
    },
    updateLimit(newLimit) {
      this.offset = 0
      this.fetchDevices()
    },
    handleRefresh() {
      this.searchQuery = '';
      this.fetchOrgs()
    },
    prevPage() {
      if (this.offset > 0) {
        this.offset -= this.limit
        this.fetchOrgs()
      }
    },
    nextPage() {
      if (this.hasMoreData) {
        this.offset += this.limit
        this.fetchOrgs()
      }
    },
    getSelected(item) {
      this.selectedOrg = item
    },
    labelSort(type, menu) {
      let sort = menu ? type : event.target.textContent.trim()
      this.sortBy = sort
      if (sort == this.sortBy) {
        this.orderAsc = !this.orderAsc
      } else {
        this.orderAsc = true
      }
      switch (sort.toLowerCase()) {
        case "code":
          this.sortData("code")
          break
        case "organization name":
          this.sortData("name")
          break
        case "business name":
          this.sortData("businessName")
          break
        case "business type":
          this.sortData("businessType")
          break
        case "contact name":
          this.sortData("contactName")
          break
        case "contact email":
          this.sortData("contactEmail")
          break
        case "contact phone":
          this.sortData("contactPhone")
          break
        case "domain":
          this.sortData("domain")
          break
        default:
          return null
      }
    },
    sortData(sortValue) {
      const sortedData = this.tableData.sort((a, b) => {
        if (this.orderAsc) {
          return a[sortValue] > b[sortValue] ? 1 : -1
        } else {
          return a[sortValue] < b[sortValue] ? 1 : -1
        }
      })
      this.tableData = sortedData
    },
    createOrg() {
      this.clientSelected = null;
      this.touched.clientName = false;
      this.touched.businessType = false;
      this.touched.businessName = false;
      this.touched.domain = false;
      this.touched.contactName = false;
      this.touched.contactEmail = false;
      this.touched.contactPhone = false;
      this.clientName = '';
      this.businessType = '';
      this.businessName = '';
      this.domain = '';
      this.contactName = '';
      this.contactEmail = '';
      this.contactPhone = '';
      this.locationsData = [];
      this.enableClearingHouseIntegration = false;
      this.showClientFormModal = true;
    },
    createLocation() {
      this.locationSelected = null;
      this.touched.locationName = false;
      this.touched.regionName = false;
      this.touched.device = false;
      this.touched.deviceStatus = false;
      this.touched.deviceStartDate = false;
      this.touched.deviceEndDate = false;
      this.touched.address = false;
      this.touched.city = false;
      this.touched.state = false;
      this.touched.country = false;
      this.touched.zip = false;
      this.touched.ein = false;
      this.touched.npi = false;
      this.touched.payer = false;
      this.touched.vendorSiteId = false;
      this.locationName = '';
      this.regionName = '';
      this.device = '';
      this.deviceStatus = '';
      this.deviceStartDate = '';
      this.deviceEndDate = '';
      this.address = '';
      this.city = '';
      this.state = '';
      if (this.countries.length === 1) {
        this.country = this.countries[0].LookupId;
      } else {
        this.country = '';
      }
      this.zip = '';
      this.ein = '';
      this.npi = '';
      this.vendorSiteId = null;
      this.payer = null;
      this.showLocationFormModal = true;
    },
    async handleSaveLocation() {
      this.touched.locationName = true;
      this.touched.regionName = true;
      this.touched.device = true;
      this.touched.deviceStatus = true;
      this.touched.deviceStartDate = true;
      this.touched.deviceEndDate = true;
      this.touched.address = true;
      this.touched.city = true;
      this.touched.state = true;
      this.touched.country = true;
      this.touched.zip = true;
      this.touched.ein = true;
      this.touched.npi = true;
      this.touched.payer = true;
      this.touched.vendorSiteId = true;
      const valid = await this.$validator.validateAll();
      if (!valid) return;
      const internalId = this.locationSelected && this.locationSelected.internalId ? this.locationSelected.internalId : (Math.random() + 1).toString(36).substring(7)
      const payer = this.ensoraPayers.find(i => i.name === this.payer);
      const locationData = {
        internalId: internalId,
        id: this.locationSelected ? this.locationSelected.id : null,
        deviceLocationId: this.locationSelected ? this.locationSelected.deviceLocationId : null,
        locationName: this.locationName,
        regionId: this.regionName,
        deviceId: this.device,
        deviceStatus: this.deviceStatus,
        deviceStartDate: this.deviceStartDate,
        deviceEndDate: this.deviceEndDate,
        ein: this.ein,
        npi: this.npi,
        vendorSiteId: this.vendorSiteId,
        ensoraPayerId: payer ? payer.id : null,
        address: {
          id: this.locationSelected ? this.locationSelected.address.id : null,
          address: this.address,
          city: this.city,
          state: this.state,
          country: this.country,
          zipCode: this.zip
        }
      }
      const index = this.locationsData.findIndex(i => i.internalId === internalId);
      if (index >= 0) {
        this.locationsData[index] = locationData;
      } else {
        this.locationsData.unshift(locationData);
      }
      this.closeLocationFormModal();
    },
    closeLocationFormModal() {
      this.locationSelected = null;
      this.showLocationFormModal = false;
      setTimeout(() => {
        const element = document.querySelectorAll('#client-tabs > div.md-tabs-navigation.md-elevation-0 > button:nth-child(2) > div')[0];
        if (element) {
          element.click()
        }
      }, 50);
    },
    handleEditLocation(item) {
      this.locationSelected = item;
      this.touched.locationName = false;
      this.touched.regionName = false;
      this.touched.device = false;
      this.touched.deviceStatus = false;
      this.touched.deviceStartDate = false;
      this.touched.deviceEndDate = false;
      this.touched.address = false;
      this.touched.city = false;
      this.touched.state = false;
      this.touched.country = false;
      this.touched.zip = false;
      this.touched.ein = false;
      this.touched.npi = false;
      this.touched.vendorSiteId = false;
      this.touched.payer = false;
      this.locationName = item.locationName;
      this.regionName = item.regionId;
      this.device = item.deviceId;
      this.deviceStatus = item.deviceStatus;
      this.deviceStartDate = item.deviceStartDate ? new Date(item.deviceStartDate).toISOString().slice(0, 10) : '';
      this.deviceEndDate = item.deviceEndDate ? new Date(item.deviceEndDate).toISOString().slice(0, 10) : '';
      this.address = item.address.address;
      this.city = item.address.city;
      this.state = item.address.state;
      this.country = item.address.country;
      this.zip = item.address.zipCode;
      this.ein = item.ein;
      this.npi = item.npi;
      this.vendorSiteId = item.vendorSiteId;
      const payer = this.ensoraPayers.find(i => i.id === item.ensoraPayerId);
      this.payer = payer ? payer.name : '';
      this.showLocationFormModal = true;
    },
    async handleRemoveLocation(item) {
      const response = await Swal.fire({
        title: "Are you sure?",
        text: "Do you want to remove this location from this client?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, remove it!"
      })
      if (response.value) {
        this.locationsData = this.locationsData.filter(i => i.internalId !== item.internalId)
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.md-table {
  max-height: 67dvh;
  overflow: auto;
}

.md-table-cell {
  padding: 2px 8px;
  font-size: 14px;
}

.text-right ::v-deep .md-table-cell-container {
  display: flex;
  justify-content: flex-end;
}

.md-table ::v-deep .md-table-head:last-child {
  text-align: left;
}

.table-shopping {
  table>thead>tr>th {
    text-transform: uppercase;
  }

  table>thead>tr>.md-table-head .md-table-head-label {
    font-size: 0.75rem;

    b {
      display: block;
      margin-bottom: 3px;
    }
  }

  .td-organization {
    font-size: 1em !important;
    line-height: 1.1;

    small {
      color: green;
      font-size: 0.77em;
    }
  }

  .td-organization {
    min-width: 200px;
  }

  .td-phone {
    text-align: left;
    min-width: 150px;

    small {
      margin-right: 3px;
    }
  }

  .img-container {
    width: 120px;
    max-height: 160px;
    overflow: hidden;
    display: block;

    img {
      width: 100%;
    }
  }
}

.md-table-row:hover {
  background-color: #74b5ff !important;
  color: white;
}

.table-striped {
  tbody>tr:nth-of-type(odd) {
    background-color: #edf2f7;
  }

  tbody>tr:nth-of-type(even) {
    background-color: #ffffff;
  }
}

.pagination-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 15px;
}

.pagination-container span {
  margin: 0 15px;
}
</style>
